export const CARTA_SERVICOS_LIST = 'CARTA_SERVICOS_LIST';
export const CARTA_SERVICOS_LIST_START = 'CARTA_SERVICOS_LIST_START';
export const CARTA_SERVICOS_LIST_SUCCESS = 'CARTA_SERVICOS_LIST_SUCCESS';
export const CARTA_SERVICOS_LIST_ERROR = 'CARTA_SERVICOS_LIST_ERROR';
